import { KeyVisualBlog } from '@pixum/key-visual';
import { KeyVisualPicture } from '../partials';
import type { KeyVisualEditorialProps } from '../types';

/**
 * KeyVisualEditorial component - Blog variant of the key visual.
 *
 * Optimized layout for blog/article pages with metadata (author, publish date, read time).
 *
 * @param props - KeyVisual variant component properties
 * @returns Rendered blog key visual variant
 */
export function KeyVisualEditorial(props: KeyVisualEditorialProps) {
  const {
    keyVisual: { image, title, pictureData, imageVariantsByDeviceSize, overline, editorialMeta },
    device,
    text,
  } = props;

  const { authorHref, authorPrefix, ...blogMetadata } = editorialMeta ?? {};

  return (
    <KeyVisualBlog
      categoryText={overline}
      headlineText={title}
      metadata={blogMetadata}
      summaryText={text}
      media={
        <KeyVisualPicture
          image={image}
          pictureData={pictureData}
          imageVariantsByDeviceSize={imageVariantsByDeviceSize}
          device={device}
        />
      }
      withMediaDecoration
      authorPrefix={authorPrefix}
      authorHref={authorHref}
    />
  );
}
